const distributorOptions = [
    { label: 'Distribuidor A', value: '1' },
    { label: 'Distribuidor B', value: '2' }
]



const notaFiscalStatusOptions = [
    { label: 'Todos', value: '' },
    { label: 'Captado', value: 'captado' },
    { label: 'Aprovado', value: 'aprovado' },
    { label: 'Faturado', value: 'faturado' },
    { label: 'Entregue', value: 'entregue' },
    { label: 'Cancelado', value: 'cancelado' }
]



const cadastroVendedoresStatusOptions = [
    { label: 'Todos', value: '' },
    { label: 'Ativo', value: 'Ativo' },
    { label: 'Inativo', value: 'Inativo' }
]

const statusPrecoEstoqueOptions = [
    { label: 'Todos', value: '' },
    { label: 'Preço', value: 'preco' },
    { label: 'Estoque', value: 'estoque' }
]

const noYesOptions = [
    { label: 'Não', value: '' },
    { label: 'Sim', value: 'SIM' }

]

const allYesNoOptions = [
    { label: 'Todos', value: '' },
    { label: 'Sim', value: 'SIM' },
    { label: 'Não', value: 'NAO' }
]

const allOnlineOfflineOptions = [
    { label: 'Todos', value: '' },
    { label: 'Online', value: 'SIM' },
    { label: 'Offline', value: 'NAO' }
]

const statusOptions = [
    { label: 'Captado', value: 'captado' },
    { label: 'Aprovado', value: 'aprovado' },
    { label: 'Faturado', value: 'faturado' },
    { label: 'Entregue', value: 'entregue' },
    { label: 'Cancelado', value: 'cancelado' },
    { label: 'Apurado', value: 'apurado' }
]

const ativoInativoOptions = [
    { label: 'Todos', value: '' },
    { label: 'Ativo', value: 'Ativo' },
    { label: 'Inativo', value: 'Inativo' }
]

const cadastroLojistasStatusOptions = [
    { label: 'Todos', value: '' },
    { label: 'Pré-Aprovado', value: 'PREAPV' },
    { label: 'Aprovado', value: 'APV' },
    { label: 'Reprovado', value: 'RPV' }
]

const mecanicaCadastroPromoUlOptions = [
    { label: 'Lista Sugerida', value: 'Lista Sugerida' },
    { label: 'Rebaixa', value: 'Rebaixa' },
    { label: 'Cupom', value: 'Cupom' },
    { label: 'A + B', value: 'A+B' }
]

const mecanicaConsumoPromoUlOptions = [
    { label: 'Lista Sugerida', value: 'Lista Sugerida' },
    { label: 'Rebaixa', value: 'Rebaixa' },
    { label: 'Cupom', value: 'Cupom' },
    { label: 'A + B', value: 'A+B' }
]

const statusCadastroPromoUlOptions = [
    { label: 'Ativo', value: 'Ativo' },
    { label: 'Inativo', value: 'Inativo' },
]

const canalVendaPromoUlOptions = [
    { label: 'Whatsapp', value: 'Whatsapp' },
    { label: 'Site, APP', value: 'Site, APP' },
    { label: 'Site, APP, Whatsapp', value: 'Site, APP, Whatsapp' }
]

export const pedidos = [
    { type: 'radio', label: 'Filtrar por data', name: 'filterByDate', options: noYesOptions, default: '' },
    { type: 'radio', label: 'Agrupar por Pedido', name: 'groupBySKU', options: noYesOptions, default: '' },
    { type: 'select', label: 'Status', name: 'status', default: 'captado', options: statusOptions },
    
    { type: 'date', label: 'Início', name: 'dtstart', required: true, hideIf: { field: 'filterByDate', value: '' } },
    { type: 'date', label: 'Término', name: 'dtend', required: true, hideIf: { field: 'filterByDate', value: '' } },

    { type: 'dropdown', label: 'Distribuidores', name: 'distributors', isMulti: true },
    { type: 'dropdown', label: 'Indústrias', name: 'industries', isMulti: true, hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'dropdown', label: 'Regionais', name: 'regions', isMulti: true, hideIf: { field: 'groupBySKU', value: 'SIM' } },

    { type: 'text', label: 'CNPJ', name: 'cnpj', mask: 'cnpj' },
    { type: 'text', label: 'Meio de Pagamento', name: 'meioPagamento' },
    { type: 'text', label: 'Prazo de Pagamento', name: 'prazoPagamento' },
    { type: 'dropdown', label: 'Grupo', name: 'grupo', hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'dropdown', label: 'Família Produto', name: 'familiaProduto', hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'dropdown', label: 'Origem Pedidos', name: 'canalVendas', hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'dropdown', label: 'Tipo de Venda', name: 'tipoVenda', hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'text', label: 'ID do Pedido', name: 'idPedido' },
    { type: 'text', label: 'ID SKU', name: 'idSKU', hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'text', label: 'Nome do Produto', name: 'produto', hideIf: { field: 'groupBySKU', value: 'SIM' } }
]

export const cadastro_lojistas = [
    { type: 'select', label: 'Status', name: 'status', options: cadastroLojistasStatusOptions },

    { type: 'dropdown', label: 'Distribuidores', name: 'distributors', isMulti: true },
    { type: 'dropdown', label: 'Indústrias', name: 'industries', isMulti: true },
    { type: 'text', label: 'CNPJ', name: 'cnpj', mask: 'cnpj' },
    { type: 'dropdown', label: 'Política de Preço', name: 'politicaPreco' },
    { type: 'radio', label: 'Blocklist', name: 'isBlockList', options: allYesNoOptions, default: '' },

    { type: 'text', label: 'Razão Social', name: 'razaoSocial' },
    { type: 'dropdown', label: 'Unidade de Negócio', name: 'bu', isMulti: true },
    { type: 'dropdown', label: 'Estado', name: 'UF' },
    { type: 'text', label: 'Cidade', name: 'cidade' },
    { type: 'text', label: 'ID Rede', name: 'idRede' },
    { type: 'text', label: 'ID Grupo Econômico', name: 'idGrupoEconomico' },


    /*{ type: 'dropdown', label: 'Regionais', name: 'regions', isMulti: true },

    
    
    
    
    */
    
    
]

export const vendedor_distribuidor = [
    { type: 'select', label: 'Status', name: 'status', options: cadastroVendedoresStatusOptions },

    { type: 'dropdown', label: 'Distribuidores', name: 'distributors', isMulti: true },

    { type: 'text', label: 'Nome do Vendedor', name: 'name' },
    { type: 'text', label: 'CPF do Vendedor', name: 'cpfVendedor', mask: 'cpf' },
    { type: 'text', label: 'E-mail do Vendedor', name: 'emailVendedor' },



    { type: 'text', label: 'Grupo', name: 'grupo'},
    { type: 'text', label: 'ID do Grupo', name: 'idGrupo'},
    { type: 'dropdown', label: 'Perfil', name: 'perfil'},
    { type: 'dropdown', label: 'Seller Group Aprov', name: 'sellerGroupAprov'},
]

export const distribuidor_prioritario = [
    { type: 'dropdown', label: 'Distribuidores', name: 'distributors', isMulti: true },
    { type: 'dropdown', label: 'Indústrias', name: 'industries', isMulti: true },
    { type: 'dropdown', label: 'Regionais', name: 'regions', isMulti: true },
    { type: 'dropdown', label: 'Unidade de Negócio', name: 'bu', isMulti: true },

    { type: 'text', label: 'Cep Inicial', name: 'cepInicial' },
    { type: 'text', label: 'Cep Final', name: 'cepFinal' },
    { type: 'text', label: 'Segmento', name: 'segmento' },
    { type: 'text', label: 'Estado', name: 'UF' },
    { type: 'text', label: 'Municipio', name: 'municipio' }
]

export const nota_fiscal = [
    { type: 'select', label: 'Status', name: 'status', options: notaFiscalStatusOptions },
    { type: 'text', label: 'ID do Pedido', name: 'idPedido' },

    { type: 'date', label: 'Início', name: 'dtstart', required: true },
    { type: 'date', label: 'Término', name: 'dtend', required: true },



    { type: 'dropdown', label: 'Distribuidores', name: 'distributors', isMulti: true },
    { type: 'dropdown', label: 'Indústrias', name: 'industries', isMulti: true, hideIf: { field: 'groupBySKU', value: 'SIM' } },

    { type: 'text', label: 'CNPJ', name: 'cnpj', mask: 'cnpj' },
    { type: 'text', label: 'Meio de Pagamento', name: 'meioPagamento' },
    { type: 'text', label: 'Prazo de Pagamento', name: 'prazoPagamento' },

    { type: 'radio', label: 'Data Nota Fiscal Integração', name: 'dataNFIntegracao', options: allYesNoOptions, default: '' },
    { type: 'radio', label: 'Data Faturado Integração', name: 'dataFaturadoIntegracao', options: allYesNoOptions, default: '' },

]

export const ultimo_preco_estoque = [
    { type: 'radio', label: 'Filtrar por data', name: 'filterByDate', options: noYesOptions, default: '' },
    { type: 'select', label: 'Status', name: 'status', options: statusPrecoEstoqueOptions, default: 'estoque', hideIf: { field: 'filterByDate', value: '' } },

    { type: 'date', label: 'Selecionar Data', name: 'dtstart', hideIf: { field: 'filterByDate', value: '' } },

    { type: 'dropdown', label: 'Distribuidores', name: 'distributors', isMulti: true },
    { type: 'dropdown', label: 'Indústrias', name: 'industries', isMulti: true, hideIf: { field: 'groupBySKU', value: 'SIM' } },


    { type: 'text', label: 'SKU', name: 'idSKU' },
    { type: 'text', label: 'EAN', name: 'ean' },
    { type: 'text', label: 'Nome do Produto', name: 'produto' },
    { type: 'dropdown', label: 'Família Produto', name: 'familiaProduto' },
    { type: 'dropdown', label: 'Marcas', name: 'marca' },
    { type: 'dropdown', label: 'Grupos', name: 'grupo' },
    { type: 'dropdown', label: 'Política de Preço', name: 'politicaPreco' },
    { type: 'dropdown', label: 'Tipo de Preço', name: 'tipoPreco' },
    { type: 'text', label: 'Valor do Preço', name: 'valorPreco' },
    { type: 'text', label: 'Estoque', name: 'estoque' },
    //{ type: 'text', label: 'Integração', name: 'integracoes' },

    { type: 'radio', label: 'Status do Produto', name: 'statusProduto', options: allOnlineOfflineOptions, default: '' },
]

export const faixa_cep_lojista = [
    { type: 'dropdown', label: 'Distribuidores', name: 'distributors', isMulti: true },
    { type: 'dropdown', label: 'Indústrias', name: 'industries', isMulti: true },

    { type: 'dropdown', label: 'Unidade de Negócio', name: 'bu', isMulti: true },

    { type: 'text', label: 'CNPJ', name: 'cnpj', mask: 'cnpj' },
    { type: 'text', label: 'Cep Inicial', name: 'cepInicial' },
    { type: 'text', label: 'Cep Final', name: 'cepFinal' },
    { type: 'text', label: 'Estado', name: 'UF' }
]


export const promocoes = [
    { type: 'select', label: 'Status', name: 'status', options: statusOptions },
    { type: 'radio', label: 'Filtrar por data', name: 'filterByDate', options: noYesOptions, default: '' },
    { type: 'date', label: 'Início', name: 'dtstart', required: true, hideIf: { field: 'filterByDate', value: '' } },
    { type: 'date', label: 'Término', name: 'dtend', required: true, hideIf: { field: 'filterByDate', value: '' } },

    { type: 'radio', label: 'Agrupar por Pedido', name: 'groupBySKU', options: noYesOptions, default: '' },



    { type: 'dropdown', label: 'Distribuidores', name: 'distributors', isMulti: true },
    { type: 'dropdown', label: 'Indústrias', name: 'industries', isMulti: true, hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'dropdown', label: 'Regionais', name: 'regions', isMulti: true, hideIf: { field: 'groupBySKU', value: 'SIM' } },

    { type: 'text', label: 'CNPJ', name: 'cnpj', mask: 'cnpj' },
    { type: 'text', label: 'Nome Promoção', name: 'regraPromocao', hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'text', label: 'ID Regra', name: 'idRegra', hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'dropdown', label: 'Grupo', name: 'grupo', hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'dropdown', label: 'Família Produto', name: 'familiaProduto', hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'text', label: 'ID do Pedido', name: 'idPedido' },
    { type: 'text', label: 'ID SKU', name: 'idSKU', hideIf: { field: 'groupBySKU', value: 'SIM' } },
    { type: 'text', label: 'Nome do Produto', name: 'produto', hideIf: { field: 'groupBySKU', value: 'SIM' } }

]

export const master_interno = [
    { type: 'radio', label: 'Filtrar por data', name: 'filterByDate', options: noYesOptions, default: '' },
    { type: 'radio', label: 'Abrir por SKU', name: 'bySKU', options: noYesOptions, default: '' },


    { type: 'date', label: 'Data Cadastro Início', name: 'dtstart', required: true, hideIf: { field: 'filterByDate', value: '' } },
    { type: 'date', label: 'Data Cadastro Término', name: 'dtend', required: true, hideIf: { field: 'filterByDate', value: '' } },
    { type: 'dropdown', label: 'Indústrias', name: 'industriesName', isMulti: true },
    { type: 'dropdown', label: 'Unidade de Negócio', name: 'bu', isMulti: true },
    { type: 'select', label: 'Status', name: 'status', options: ativoInativoOptions },

    { type: 'text', label: 'EAN', name: 'ean' },

    { type: 'text', label: 'Nome do Produto', name: 'produto' },
    { type: 'dropdown', label: 'Marcas', name: 'marca' },

    { type: 'text', label: 'Tipo', name: 'tipo' },
    { type: 'dropdown', label: 'Família', name: 'familiaProduto' },
    { type: 'dropdown', label: 'Grupo', name: 'grupo' },
    { type: 'text', label: 'Sub Grupo', name: 'subgrupo' },
    { type: 'text', label: 'Group Brand', name: 'groupBrand' },
    { type: 'text', label: 'PPA', name: 'ppa' }
]

export const master_produto = [
    { type: 'radio', label: 'Filtrar por data', name: 'filterByDate', options: noYesOptions, default: '' },
    { type: 'radio', label: 'Abrir por SKU', name: 'groupBySKU', options: noYesOptions, default: '' },


    { type: 'date', label: 'Data Cadastro Início', name: 'dtstart', required: true, hideIf: { field: 'filterByDate', value: '' } },
    { type: 'date', label: 'Data Cadastro Término', name: 'dtend', required: true, hideIf: { field: 'filterByDate', value: '' } },
    { type: 'dropdown', label: 'Indústrias', name: 'industriesName', isMulti: true },
    { type: 'dropdown', label: 'Unidade de Negócio', name: 'bu', isMulti: true },
    { type: 'select', label: 'Status', name: 'status', options: ativoInativoOptions },

    { type: 'text', label: 'EAN', name: 'ean'},

    { type: 'text', label: 'Nome do Produto', name: 'produto' },
    { type: 'dropdown', label: 'Marcas', name: 'marca' },

    /*{ type: 'text', label: 'Tipo', name: 'tipo' },*/
    { type: 'dropdown', label: 'Família', name: 'familiaProduto' },
    { type: 'dropdown', label: 'Grupo', name: 'grupo' },
    { type: 'text', label: 'Sub Grupo', name: 'subgrupo' },
    /*{ type: 'text', label: 'Group Brand', name: 'groupBrand' },*/
    { type: 'text', label: 'PPA', name: 'ppa' },
    { type: 'text', label: 'ID SKU', name: 'idSKU', hideIf: { field: 'groupBySKU', value: '' }},
    /*{ type: 'dropdown', label: 'Plataforma', name: 'plataforma', isMulti: true }*/
]

export const infrapay = [
    { type: 'date', label: 'Início', name: 'dtstart', required: true, hideIf: { field: 'filterByDate', value: '' } },
    { type: 'date', label: 'Término', name: 'dtend', required: true, hideIf: { field: 'filterByDate', value: '' } }
]

export const cadastro_promo_ul = [
    {
        type: 'date',
        label: 'Data Início',
        name: 'dataHoraInicio',
        defaultToday: false,
        clearable: true,
    },
    {
        type: 'date',
        label: 'Data Fim',
        name: 'dataHoraFim',
        defaultToday: false,
        clearable: true,
    },
    {
        type: 'text',
        label: 'ID Regra',
        name: 'idRegra',
        placeholder: 'Informe um ou mais IDs separados por ; ou ,',
    },
    { type: 'text', label: 'Nome', name: 'nome' },
    { type: 'select', label: 'Mecânica', name: 'mecanica', options: mecanicaCadastroPromoUlOptions },
    { type: 'select', label: 'Status', name: 'status', options: statusCadastroPromoUlOptions },
    { type: 'select', label: 'Canal de Venda', name: 'canalDeVenda', options: canalVendaPromoUlOptions },
    
    { type: 'text', label: 'Nome Família Produto', name: 'nomeFamiliaProduto' },
    { type: 'text', label: 'Código Cupom', name: 'codigoCupom' },
]

export const consumo_promo_ul = [
    {
        type: 'date',
        label: 'Data Início',
        name: 'dataHoraInicio',
        defaultToday: false,
        clearable: true,
    },
    {
        type: 'date',
        label: 'Data Fim',
        name: 'dataHoraFim',
        defaultToday: false,
        clearable: true,
    },
    {
        type: 'text',
        label: 'ID Regra Promoção',
        name: 'idRegraPromocao',
        placeholder: 'Informe um ou mais IDs separados por ; ou ,',
    },
    { type: 'text', label: 'Nome', name: 'nome' },
    { type: 'select', label: 'Mecânica', name: 'mecanica', options: mecanicaConsumoPromoUlOptions },
    { type: 'dropdown', label: 'BU', name: 'bu', isMulti: true, optionsSource: 'consumoPromoUlBus' },
    //{ type: 'dropdown', label: 'Unidade de Negócio', name: 'bu', isMulti: true },
    { type: 'text', label: 'ID Orçamento', name: 'idOrcamento' },
    
    { type: 'dropdown', label: 'BU Patrocinadora', name: 'buPatrocinadora', isMulti: true, optionsSource: 'consumoPromoUlBus' },
]


export default {
    pedidos,
    cadastro_lojistas,
    vendedor_distribuidor,
    distribuidor_prioritario,
    nota_fiscal,
    ultimo_preco_estoque,
    promocoes,
    master_interno,
    master_produto,
    infrapay,
    faixa_cep_lojista,
    cadastro_promo_ul,
    consumo_promo_ul
}